/*
 * @version: V1.0.0
 * @Date: 2023-08-14 15:30:46
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-13 14:30:57
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\api\material\index.js
 * @Descripttion:
 */
import request from '@/utils/request'

// 获取物料列表数据
export function getMaterial(params) {
  return request({
    url: '/material/list',
    method: 'get',
    params
  })
}

export function getMaterialInfo(id) {
  return request({
    url: `/material/${id}`,
    method: 'get',
  })
}
// 物料解除绑定
export function removeMaterialBind(data) {
  return request({
    url: '/material/relieveBindingDi',
    method: 'post',
    data
  })
}

// 物料新增
export function saveOrUpdateMaterial(data) {
  return request({
    url: '/material/saveOrUpdate',
    method: 'post',
    data
  })
}

// 物料同步
export function materialAsync(params) {
  return request({
    url: '/material/syncMaterial',
    method: 'get',
    params
  })
}

// /product/list4materialBindDI
// 获取DI，未绑定物料
export function getFilterDIList(data) {
  return request({
    url: `/material/diSelectPage`,
    method: 'post',
    data
  })
}


// 物料绑定
export function materialBind(data) {
  return request({
    url: '/material/bindingDi',
    method: 'post',
    data
  })
}

// 物料分组
export function getMaterialCategory(params) {
  return request({
    url: '/udiMaterialGroup/queryList',
    method: 'get',
    params
  })
}

// 新增物料分组
export function saveOrUpdateMaterialCategory(data) {
  return request({
    url: '/udiMaterialGroup/saveOrUpdate',
    method: 'post',
    data
  })
}

// 新增物料分组
export function removeMaterialCategory(id) {
  return request({
    url: `/udiMaterialGroup/delete/${id}`,
    method: 'get',
  })
}



/**
 * 导入产品及DI - EXCEL文件提交
 * @param {array} products
 */
export function importDataExcel(data) {
  return request({
    url: '/material/import-excel',
    method: 'post',
    data
  })
}
// 删除物料
export function removeMaterial(id) {
  return request({
    url: `/material/${id}`,
    method: 'delete',
  })
}
